<template>
  <div class="lightbox-book-detail">
    <div class="lightbox-book-detail__inner">
      <h2 class="lightbox-book-detail__ttl">プラン変更が完了しました。</h2>
      <p class="lightbox-book-detail__sentence">PREMIUMを解約しました。{{userSettings.using_plan.expires_date | dateFormat}}までの間、引き続きPREMIUMの機能はご利用いただけます。</p>
      <button class="btn-square" @click="click_close">閉じる</button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    computed: {
      userSettings() {
        return this.$store.getters.userSettings;
      }
    },
    methods: {
      click_close() {
        this.$store.dispatch("hideLightBox");
      }
    }
  }
</script>

<style scoped lang="scss">
  .lightbox-book-detail {
    padding: 0 15px;
    &__inner {
      max-width: 440px;
      margin: 0 auto;
      padding: 10px 15px;
      background-color: #fff;
    }
    &__ttl {
      font-size: 18px;
      font-size: 1.8rem;
      font-weight: bold;
      margin-bottom: 10px;
    }
    &__sentence {
      text-align: justify;
      margin-bottom: 25px;
    }
    .btn-square {
      margin-bottom: 8px;
      &--app {
        color: #fff;
        background-color: #9b9b9b;
        border-color: #919191;
      }
    }
    .book-bottom {
      padding: 20px 0 0;
      a {
        color: #FF5B60;
        text-decoration: underline;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lightbox/CancelSubscriptionResult.vue